import { IRfeDialogResult } from '../../typings/window';

export interface IRfeDialogCloseHandler {
	(result: IRfeDialogResult): void;
}

export interface IRfeDialogCancelHandler {
	(result: IRfeDialogResult): void;
}

export default class RfeWebDialog {
	public static show(url: string, close?: IRfeDialogCloseHandler, cancel?: IRfeDialogCancelHandler): void {
		window.WebDialog.show(url, close, cancel);
	}

	public static showAsync(url: string): Promise<IRfeDialogResult> {
		return new Promise<IRfeDialogResult>((r, rj) => {
			window.WebDialog.show(url, r, rj);
		});
	}
}
